import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  getAllAllotmentTransactions,
  getAllMachines,
  getAllotmentById,
  getAllotmentTransactions,
  insertAllotmentTransactions,
  updateAllotmentPayment,
  uploadChequeImage,
} from '../../Services/AllAllotments';
import { dismissLoader, presentLoader } from '../../Services/loader';
import { errorTost, successTost } from '../../Services/Toast';
import Button from '../../Subcomponents/Button';
import CameraCapture from '../../Subcomponents/CameraCapture';
import CustomInput from '../../Subcomponents/CustomInput';
import CustomRadio from '../../Subcomponents/CustomRadio';
import DateComponent from '../../Subcomponents/DateComponent';
import DropDown from '../../Subcomponents/DropDown';
import LoaderWithMsg from '../../Subcomponents/LoaderWithMsg';
import { supabase } from '../../supabaseClient';
import cssClasses from './PaymentModal.module.css';
import PinIcon from '../../Assets/Images/Sustenance/pinIcon.svg';
import RupeeIcon from '../../Assets/Images/Sustenance/RupeeIcon.svg';
import LoaderModal from '../LoaderModal/LoaderModal';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from '@mui/lab';
import { addLeadLogs } from '../../Services/Lead';
import { createPaymentLink } from '../../Services/PaymentApi';

export default function PaymentModal({ allotment, setOpenPaymentModal, desk, showBackToFastBooking = false }) {
  const navigate = useNavigate()
  const [allotmentDetails, setAllotmentDetails] = useState(null);
  const [machine, setMachine] = useState(null);
  const [paymentMode, setPaymentMode] = useState('Card');
  const [isLoading, setIsLoading] = useState(false);
  const [loaderMsg, setLoaderMsg] = useState('');
  const [message, setMessage] = useState('');
  const [ptrnNo, setPtrnNo] = useState('');
  const [mode, setMode] = useState('');
  const [timestamp, setTimestamp] = useState(0);
  const [amount, setAmount] = useState(0);
  const [amountToBePaid, setAmountToBePaid] = useState(0);
  const [allTransactions, setAllTransactions] = useState([]);
  const [allMachines, setAllMachines] = useState([]);
  const [transactionOpen, setTransactionOpen] = useState(false);
  const [openCaptureModal, setOpenCaptureModal] = useState(false);
  const [openLoaderModal, setOpenLoaderModal] = useState(false);
  const [chequeHelperText, setChequeHelperText] = useState({
    issuerName: '',
    chequeNumber: '',
    bankName: '',
    chequeDate: '',
    chequeImg: '',
  });
  const [PaymentHelperText, setPaymentHelperText] = useState({
    PartialAmount: '',
  });
  const [chequeDetails, setChequeDetails] = useState({
    issuerName: '',
    chequeNumber: '',
    bankName: '',
    chequeDate: null,
    chequeImg: null,
    remarks: '',
  });

  useEffect(() => {
    getAllMachines().then((resp) => {
      resp.data.forEach((e) => { e.label = e.machineName; e.label = e.machineName })
      setAllMachines(resp.data)
    })
  }, [])

  useEffect(() => {
    if (allotment.allotmentpaymentid && !openLoaderModal) {
      presentLoader();
      getAllotmentById(allotment.allotmentpaymentid)
        .then((resp) => {
          console.log(resp.data[0]);
          // let amt = resp.data[0]?.inventoryMergedId?.inventoryMergeId ? resp.data[0].inventoryMergedId.unit1Id.projectId.bookingAmt : resp.data[0].unitId.projectId.bookingAmt
          let amt = resp.data[0]?.bookingAmt?.total
          if (resp.data[0]?.paymentId?.eventId?.adjustTokenAmt && resp.data[0]?.paymentId?.status !== 'adjusted' && resp.data[0]?.pricingType !== 'preselect') {
            setAmountToBePaid(parseInt(amt) - resp.data[0]?.paymentId?.paidAmount)
          } else {
            setAmountToBePaid(parseInt(amt))
            // setAmountToBePaid(parseInt(resp.data[0]?.paymentId?.amount))
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
          // desk = resp.data[0].pricingType === 'preselect' ? resp.data[0].paymentId?.eventId?.preselectPaymentModes : desk
          setAllotmentDetails(resp.data[0]);
          setAmount(resp.data[0].pricingType === 'preselect' ? (amountToBePaid - resp.data[0].paidAmount) : 0)
          getAllAllotmentTransactions(allotment.allotmentpaymentid).then((allTransactions) => {
            console.log(allTransactions)
            setAllTransactions(allTransactions.data)
            getAllotmentTransactions(allotment.allotmentpaymentid).then(
              (transactions) => {
                if (transactions.data.length > 0) {
                  transactions.data.forEach((ele, index) => {
                    axios
                      .post(
                        process.env.REACT_APP_PAYMENT_LINK_URL +
                        'payments/check-pos-transaction-status',
                        {
                          ptrnNo: parseInt(ele.paymentDetails.ptrnNo),
                          merchantId: ele.machineId.merchantId,
                          securityToken: ele.machineId.securityToken,
                          imei: ele.machineId.imei,
                          merchantStorePosCode: ele.machineId.merchantStorePosCode,
                        }
                      )
                      .then(async (statusRes) => {
                        if (statusRes.data.message === 'expired') {
                          await supabase
                            .from('AllotmentTransactions')
                            .update({ status: 'expired' })
                            .eq(
                              'paymentDetails->ptrnNo',
                              ele.paymentDetails.ptrnNo
                            )
                            .then(async (_re) => {
                              if (index === transactions.data.length - 1) {
                                dismissLoader();
                              }
                            });
                        } else if (statusRes.data.message === 'completed') {
                          let leadstatus = ''
                          let allotmentstatus = ''
                          let totalAmount = 0
                          if (resp.data[0]?.paymentId?.eventId?.adjustTokenAmt && resp.data[0]?.paymentId?.status !== 'adjusted' && resp.data[0]?.paymentId?.pricingType !== 'preselect') {
                            totalAmount = (parseInt(resp.data[0].bookingAmt?.total) - resp.data[0]?.paymentId?.paidAmount)
                          } else {
                            totalAmount = (parseInt(resp.data[0].bookingAmt?.total))
                          }
                          let fullAmount = amountToBePaid ? amountToBePaid : totalAmount
                          if (fullAmount - resp.data[0].paidAmount > parseInt(ele.amount)) {
                            allotmentstatus = 'Partial Payment Done'
                            if (resp.data[0].pricingType === 'preselect') {
                              leadstatus = 'Preselect Partial Payment Done'
                            } else {
                              leadstatus = 'Allotment Partial Payment Done'
                            }
                          } else {
                            allotmentstatus = 'Payment Complete'
                            if (resp.data[0].pricingType === 'preselect') {
                              leadstatus = 'Preselect Price Confirmation Pending'
                            } else {
                              leadstatus = 'Allotment Payment Complete'
                            }
                          }
                          let paidAmt = resp.data[0].paidAmt ? resp.data[0].paidAmt : { ocr: 0, gst: 0, sdr: 0 }
                          let currentAmt = parseInt(ele.amount)
                          let ocr = 0
                          let gst = 0
                          let sdr = 0
                          if (currentAmt <= (resp.data[0].bookingAmt.ocr - paidAmt.ocr)) {
                            ocr = currentAmt
                            currentAmt = 0
                          } else {
                            ocr = (resp.data[0].bookingAmt.ocr - paidAmt.ocr)
                            currentAmt = currentAmt - (resp.data[0].bookingAmt.ocr - paidAmt.ocr)
                          }
                          if (currentAmt <= (resp.data[0].bookingAmt.gst - paidAmt.gst)) {
                            gst = currentAmt
                            currentAmt = 0
                          } else {
                            gst = (resp.data[0].bookingAmt.gst - paidAmt.gst)
                            currentAmt = currentAmt - (resp.data[0].bookingAmt.gst - paidAmt.gst)
                          }
                          if (currentAmt <= (resp.data[0].bookingAmt.sdr - paidAmt.sdr)) {
                            sdr = currentAmt
                            currentAmt = 0
                          } else {
                            sdr = (resp.data[0].bookingAmt.sdr - paidAmt.sdr)
                            currentAmt = currentAmt - (resp.data[0].bookingAmt.sdr - paidAmt.sdr)
                          }
                          paidAmt = {
                            ocr: paidAmt.ocr + ocr,
                            gst: paidAmt.gst + gst,
                            sdr: paidAmt.sdr + sdr
                          }
                          await supabase
                            .from('AllotmentPayment')
                            .update({
                              paidAmt: paidAmt,
                              status: allotmentstatus,
                              preselectConfirmation: allotmentstatus === 'Preselect Price Confirmation Pending' ? 'confirmation pending' : resp.data[0].preselectConfirmation,
                              paidAmount: parseFloat(
                                resp.data[0].paidAmount + parseInt(ele.amount)
                              ),
                            })
                            .eq(
                              'allotmentPaymentId',
                              resp.data[0].allotmentPaymentId
                            )
                            .then(async (_resp) => {
                              await supabase
                                .from('AllotmentTransactions')
                                .update({ ocr: ocr, gst: gst, sdr: sdr, status: 'complete' })
                                .eq(
                                  'paymentDetails->ptrnNo',
                                  ele.paymentDetails.ptrnNo
                                )
                                .then(async (_re) => {
                                  // await supabase.from('LeadStatus').update({ status: ((payments.data[i].totalCost - resp.data[0].paidAmount) > ele.amount) ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete' }).eq('leadId', payments.data[0].leadId).then((_r) => {
                                  await supabase
                                    .from('LeadStatus')
                                    .update({
                                      status: leadstatus
                                    })
                                    .eq('leadId', resp.data[0].leadId.leadId)
                                    .then(async (_r) => {
                                      let obj = {
                                        leadId: resp.data[0].leadId.leadId,
                                        leadStatus: leadstatus,
                                        message: leadstatus
                                      }
                                      addLeadLogs(obj).then((leadLog) => { console.log(leadLog) }).catch((err) => { console.log('leadlog', err) })
                                      if (allotment.pricingType === 'preselect') {
                                        await supabase.from('EventTokenLeadRelations').update({ paidAmount: fullAmount, status: 'alloted' }).eq('paymentId', allotment.paymentId.paymentId).then((rr) => {
                                          // if (fullAmount - resp.data[0].paidAmount <= parseInt(ele.amount)) {
                                          if (
                                            index ===
                                            transactions.data.length - 1
                                          ) {
                                            dismissLoader();
                                          }
                                          if (
                                            resp.data[0].paidAmount +
                                            parseInt(ele.amount) ===
                                            fullAmount
                                          ) {
                                            setOpenPaymentModal(false);
                                          }
                                          setAllotmentDetails((pre) => {
                                            pre.paidAmount =
                                              pre.paidAmount + parseInt(ele.amount);
                                            return { ...pre };
                                          });
                                        })
                                      } else {
                                        if (fullAmount - resp.data[0].paidAmount <= parseInt(ele.amount)) {
                                          if (!resp.data[0].kycFormFilled) {
                                            supabase.from('InventoryStatus').select('*').eq('status', "Kyc Pending").then((statusRes) => {
                                              if (allotmentDetails?.inventoryMergedId && allotmentDetails?.inventoryMergedId.inventoryMergeId !== '') {
                                                supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.inventoryMergedId.unit1Id.unitId).then((updateRes) => {
                                                  supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.inventoryMergedId.unit1Id.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "kyc pending", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.inventoryMergedId.unit1Id.projectId.projectId }).then((updateRes) => {
                                                    supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.inventoryMergedId.unit2Id.unitId).then((updateRes) => {
                                                      supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.inventoryMergedId.unit1Id.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "kyc pending", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.inventoryMergedId.unit1Id.projectId.projectId }).then((updateRes) => {
                                                        if (
                                                          index ===
                                                          transactions.data.length - 1
                                                        ) {
                                                          dismissLoader();
                                                        }
                                                        if (
                                                          resp.data[0].paidAmount +
                                                          parseInt(ele.amount) ===
                                                          fullAmount
                                                        ) {
                                                          setOpenPaymentModal(false);
                                                        }
                                                        setAllotmentDetails((pre) => {
                                                          pre.paidAmount =
                                                            pre.paidAmount + parseInt(ele.amount);
                                                          return { ...pre };
                                                        });
                                                      })
                                                    })
                                                  })
                                                })
                                              } else {
                                                supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.unitId.unitId).then((updateRes) => {
                                                  supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.unitId.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "kyc pending", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.unitId.projectId.projectId }).then((updateRes) => {
                                                    if (
                                                      index ===
                                                      transactions.data.length - 1
                                                    ) {
                                                      dismissLoader();
                                                    }
                                                    if (
                                                      resp.data[0].paidAmount +
                                                      parseInt(ele.amount) ===
                                                      fullAmount
                                                    ) {
                                                      setOpenPaymentModal(false);
                                                    }
                                                    setAllotmentDetails((pre) => {
                                                      pre.paidAmount =
                                                        pre.paidAmount + parseInt(ele.amount);
                                                      return { ...pre };
                                                    });
                                                  })
                                                })
                                              }
                                            })
                                          } else {
                                            // callBookingApis()
                                          }
                                        } else {
                                          if (
                                            index ===
                                            transactions.data.length - 1
                                          ) {
                                            dismissLoader();
                                          }
                                          if (
                                            resp.data[0].paidAmount +
                                            parseInt(ele.amount) ===
                                            fullAmount
                                          ) {
                                            setOpenPaymentModal(false);
                                          }
                                          setAllotmentDetails((pre) => {
                                            pre.paidAmount =
                                              pre.paidAmount + parseInt(ele.amount);
                                            return { ...pre };
                                          });
                                        }
                                      }
                                    });
                                });
                            });
                        } else {
                          checkStatus(
                            ele.paymentDetails.ptrnNo,
                            true,
                            resp.data[0],
                            ele.amount,
                            ele.transactionTime,
                            ele.machineId
                          );
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                        setPtrnNo('');
                        setMode('expired');
                        setMessage('Please check POS internet connectivity');
                      });
                  });
                } else {
                  dismissLoader();
                }
              }
            );
          });
        })
        .catch((err) => {
          console.log(err);
          dismissLoader();
        });
    }

    console.log("allotment.allotmentpaymentid", allotment)
  }, [openLoaderModal]);

  function validateChequeDetails() {
    let flag = true;
    if (chequeDetails.issuerName === '') {
      setChequeHelperText((pre) => {
        pre.issuerName = 'Please enter issuer name';
        return { ...pre };
      });
      flag = false;
    }
    if (chequeDetails.chequeNumber === '') {
      setChequeHelperText((pre) => {
        pre.chequeNumber = 'Please enter issuer name';
        return { ...pre };
      });
      flag = false;
    }
    if (chequeDetails.bankName === '') {
      setChequeHelperText((pre) => {
        pre.bankName = 'Please enter issuer name';
        return { ...pre };
      });
      flag = false;
    }
    if (!chequeDetails.chequeDate || chequeDetails.chequeDate === '') {
      setChequeHelperText((pre) => {
        pre.chequeDate = 'Please enter issuer name';
        return { ...pre };
      });
      flag = false;
    }
    if (!chequeDetails.chequeImg) {
      errorTost('Please upload cheque image');
      flag = false;
    }
    return flag;
  }

  function OnSubmit() {
    if (parseInt(amount) > parseInt(amountToBePaid - allotmentDetails?.paidAmount)) {
      errorTost("Amount should be less than or equal to amount to be paid")
    } else {
      // if (allotmentDetails.paidAmount == 0 && allTransactions.length === 0) {
      if (allotmentDetails.status === 'On Hold') {
        presentLoader()
        axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}bookings/send-payment-email`, { leadName: allotmentDetails?.leadId?.personId?.name, allotmentPaymentId: allotmentDetails.allotmentPaymentId, leadEmail: allotmentDetails?.leadId?.personId?.email }).then((reqRes) => {
          updateUnitStatus()
        }).catch((err) => {
          updateUnitStatus()
        })
      } else {
        proceedToPay()
      }
    }
  }

  function updateUnitStatus() {
    if (allotmentDetails.pricingType !== 'preselect') {
      supabase.from('InventoryStatus').select('*').eq('status', "Payment Pending").then((statusRes) => {
        if (allotmentDetails?.inventoryMergedId && allotmentDetails?.inventoryMergedId.inventoryMergeId !== '') {
          supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.inventoryMergedId.unit1Id.unitId).then((updateRes) => {
            supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.inventoryMergedId.unit1Id.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "payment pending", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.inventoryMergedId.unit1Id.projectId.projectId }).then((updateRes) => {
              supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.inventoryMergedId.unit2Id.unitId).then((updateRes) => {
                supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.inventoryMergedId.unit1Id.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "payment pending", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.inventoryMergedId.unit1Id.projectId.projectId }).then((updateRes) => {
                  dismissLoader()
                  proceedToPay()
                }).catch((err) => {
                  dismissLoader()
                  proceedToPay()
                })
              }).catch((err) => {
                dismissLoader()
                proceedToPay()
              })
            }).catch((err) => {
              dismissLoader()
              proceedToPay()
            })
          }).catch((err) => {
            dismissLoader()
            proceedToPay()
          })
        } else {
          supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.unitId.unitId).then((updateRes) => {
            supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.unitId.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "payment pending", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.unitId.projectId.projectId }).then((updateRes) => {
              dismissLoader()
              proceedToPay()
            }).catch((err) => {
              dismissLoader()
              proceedToPay()
            })
          }).catch((err) => {
            dismissLoader()
            proceedToPay()
          })
        }
      }).catch((err) => {
        dismissLoader()
        proceedToPay()
      })
    } else {
      dismissLoader()
      proceedToPay()
    }
  }

  function proceedToPay() {
    if (paymentMode === 'Card') {
      cardPayment(allotmentDetails.allotmentPaymentId);
    } else if (paymentMode === 'Cheque') {
      let isChequeDetailsValid = validateChequeDetails();
      if (isChequeDetailsValid) {
        console.log('valid');
        let date = new Date().getTime();
        presentLoader();
        let paidAmt = allotmentDetails.paidAmt ? allotmentDetails.paidAmt : { ocr: 0, gst: 0, sdr: 0 }
        let currentAmt = parseInt(amount)
        let ocr = 0
        let gst = 0
        let sdr = 0
        if (currentAmt <= (allotmentDetails.bookingAmt.ocr - paidAmt.ocr)) {
          ocr = currentAmt
          currentAmt = 0
        } else {
          ocr = (allotmentDetails.bookingAmt.ocr - paidAmt.ocr)
          currentAmt = currentAmt - (allotmentDetails.bookingAmt.ocr - paidAmt.ocr)
        }
        if (currentAmt <= (allotmentDetails.bookingAmt.gst - paidAmt.gst)) {
          gst = currentAmt
          currentAmt = 0
        } else {
          gst = (allotmentDetails.bookingAmt.gst - paidAmt.gst)
          currentAmt = currentAmt - (allotmentDetails.bookingAmt.gst - paidAmt.gst)
        }
        if (currentAmt <= (allotmentDetails.bookingAmt.sdr - paidAmt.sdr)) {
          sdr = currentAmt
          currentAmt = 0
        } else {
          sdr = (allotmentDetails.bookingAmt.sdr - paidAmt.sdr)
          currentAmt = currentAmt - (allotmentDetails.bookingAmt.sdr - paidAmt.sdr)
        }
        paidAmt = {
          ocr: paidAmt.ocr + ocr,
          gst: paidAmt.gst + gst,
          sdr: paidAmt.sdr + sdr
        }
        insertAllotmentTransactions({
          amount: amount,
          modeOfPayment: 'Cheque',
          transactionType: 'Allotment',
          allotmentPaymentId: allotmentDetails.allotmentPaymentId,
          leadId: allotmentDetails.leadId.leadId,
          unitId: allotmentDetails.unitId ? allotmentDetails.unitId.unitId : null,
          inventoryMergeId: allotmentDetails?.inventoryMergedId?.inventoryMergeId ? allotmentDetails?.inventoryMergedId?.inventoryMergeId : null,
          chequeImageUrl: allotmentDetails?.inventoryMergedId?.inventoryMergeId ? `cheques/${allotmentDetails?.inventoryMergedId?.unit1Id?.projectId?.projectId}/Allotments/${date}` : `cheques/${allotmentDetails.unitId.projectId.projectId}/Allotments/${date}`,
          paymentDetails: chequeDetails,
          ocr: ocr,
          gst: gst,
          sdr: sdr
        }).then((transactionResp) => {
          uploadChequeImage(chequeDetails.chequeImg, allotmentDetails?.inventoryMergedId?.inventoryMergeId ? `cheques/${allotmentDetails?.inventoryMergedId?.unit1Id?.projectId?.projectId}/Allotments/${date}` : `cheques/${allotmentDetails.unitId.projectId.projectId}/Allotments/${date}`).then((imageRes) => {
            updateAllotmentPayment({ paidAmt: paidAmt, paidAmount: parseFloat(allotmentDetails.paidAmount) + parseFloat(amount), status: (amountToBePaid - allotmentDetails?.paidAmount > parseInt(amount)) ? 'Partial Payment Done' : 'Payment Complete' }, allotmentDetails.allotmentPaymentId).then(async (paymentRes) => {
              await supabase.from('LeadStatus').update({ status: amountToBePaid - allotmentDetails.paidAmount > amount ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete', }).eq('leadId', allotmentDetails.leadId.leadId).then((_r) => {
                let obj = {
                  leadId: allotmentDetails.leadId.leadId,
                  leadStatus: amountToBePaid - allotmentDetails.paidAmount > amount ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete',
                  message: `Amount Paid${parseFloat(allotmentDetails.paidAmount) + parseFloat(amount)},status  ${(amountToBePaid - allotmentDetails?.paidAmount > parseInt(amount)) ? 'Partial Payment Done' : 'Payment Complete'},modeOfPayment: Cheque,Unit${allotmentDetails?.inventoryMergedId ? allotmentDetails?.inventoryMergedId?.unit1Id?.unit1No + allotmentDetails?.inventoryMergedId?.unit2Id?.unit2No : allotmentDetails.unitId.unitNo},Project:${allotmentDetails?.inventoryMergedId?.unit1Id?.projectId?.projectName ? allotmentDetails?.inventoryMergedId?.unit1Id?.projectId?.projectName : allotmentDetails?.unitId?.projectId?.projectName}`
                }
                addLeadLogs(obj).then((leadLog) => { console.log(leadLog) }).catch((err) => { console.log('leadlog', err) })
                // if (amountToBePaid - allotmentDetails.paidAmount <= parseInt(amount)) {
                if (allotmentDetails.paidAmount + parseInt(amount) >= amountToBePaid) {
                  if (!allotmentDetails.kycFormFilled) {
                    updateInventoryStatus("cheque")
                  } else {
                    // callBookingApis()
                  }
                } else {
                  setOpenPaymentModal(false);
                }
                setAllotmentDetails((pre) => {
                  pre.paidAmount = pre.paidAmount + parseInt(amount);
                  return { ...pre };
                });
                successTost('Payment Complete');
                setChequeDetails({
                  issuerName: '',
                  chequeNumber: '',
                  bankName: '',
                  chequeDate: null,
                  chequeImg: null,
                  remarks: '',
                });
                dismissLoader();
              });
            });
          });
        });
      }
    } else {
      successTost(
        `Payment link sent to mobile number ${allotmentDetails.leadId.personId.contactNumber} and email ${allotmentDetails.leadId.personId.email}`
      );
    }
  }

  function updateInventoryStatus(mode, myamt, flag) {
    if (allotmentDetails.pricingType !== 'preselect') {
      supabase.from('InventoryStatus').select('*').eq('status', "Kyc Pending").then((statusRes) => {
        if (allotmentDetails?.inventoryMergedId && allotmentDetails?.inventoryMergedId.inventoryMergeId !== '') {
          supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.inventoryMergedId.unit1Id.unitId).then((updateRes) => {
            supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.inventoryMergedId.unit1Id.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "kyc pending", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.inventoryMergedId.unit1Id.projectId.projectId }).then((updateRes) => {
              supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.inventoryMergedId.unit2Id.unitId).then((updateRes) => {
                supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.inventoryMergedId.unit1Id.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "kyc pending", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.inventoryMergedId.unit1Id.projectId.projectId }).then((updateRes) => {
                  if (mode === 'cheque') {
                    setOpenPaymentModal(false);
                  } else {
                    if (!flag) {
                      setTransactionOpen(false);
                      setAmount(myamt);
                      setPtrnNo('');
                      setMode('complete');
                    }
                    setAllotmentDetails((pre) => {
                      pre.paidAmount = pre.paidAmount + parseInt(myamt);
                      return { ...pre };
                    });
                  }
                })
              })
            })
          })
        } else {
          supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.unitId.unitId).then((updateRes) => {
            supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.unitId.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "kyc pending", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.unitId.projectId.projectId }).then((updateRes) => {
              setOpenPaymentModal(false);
            })
          })
        }
      })
    }
  }

  function cardPayment(allotmentPaymentId) {
    console.log(allotmentPaymentId);
    if (!ptrnNo || ptrnNo === '') {
      setMode('pending');
      setMessage('Creating Transaction');
      setOpenLoaderModal(true);
      axios
        .post(
          process.env.REACT_APP_PAYMENT_LINK_URL +
          'payments/create-pos-transaction',
          {
            TransactionNumber: `${allotmentPaymentId}_${new Date().getTime()}`,
            amount: amount,
            merchantId: machine.merchantId,
            securityToken: machine.securityToken,
            imei: machine.imei,
            merchantStorePosCode: machine.merchantStorePosCode,
          }
        )
        .then(async (transactionResp) => {
          console.log(transactionResp.data);
          if (transactionResp.data.success) {
            const t = new Date().getTime() + 300000;
            setTimestamp(t);
            setMessage('Waiting for payment on POS machine');
            setPtrnNo(transactionResp.data.ptrnNo);
            await supabase
              .from('AllotmentTransactions')
              .insert({
                paymentDetails: {
                  transactionNumber: `${allotmentDetails.allotmentPaymentId
                    }_${new Date().getTime()}`,
                  ptrnNo: parseInt(transactionResp.data.ptrnNo)
                },
                machineId: machine.machineId,
                transactionTime: t,
                leadId: allotmentDetails.leadId.leadId,
                unitId: allotmentDetails.unitId ? allotmentDetails.unitId.unitId : null,
                inventoryMergeId: allotmentDetails?.inventoryMergedId?.inventoryMergeId ? allotmentDetails?.inventoryMergedId?.inventoryMergeId : null,
                allotmentPaymentId: allotmentDetails.allotmentPaymentId,
                amount: parseFloat(amount),
                transactionType: 'Allotment',
                modeOfPayment: 'POS Machine',
                status: 'pending',
              })
              .then(async (_re) => {
                setTransactionOpen(true);
                checkStatus(
                  transactionResp.data.ptrnNo,
                  false,
                  allotmentDetails,
                  amount,
                  t,
                  machine
                );
              });
          } else {
            // if (transactionResp.data.message !== 'Please complete previous transaction to continue') {
            setMode('expired');
            setMessage(transactionResp.data.message);
            // }
          }
        })
        .catch((err) => {
          setMode('expired');
          setMessage(
            'Please check POS machine internet connectivity and try again'
          );
          // errorTost("Could not create transaction! Please check POS machine internet connectivity and try again")
          // setIsLoading(false)
        });
    }
  }

  function checkStatus(ptrnNo, flag, allotment, myamt, time, machineId) {
    axios
      .post(
        process.env.REACT_APP_PAYMENT_LINK_URL +
        'payments/check-pos-transaction-status',
        {
          ptrnNo: parseInt(ptrnNo),
          merchantId: machineId.merchantId,
          securityToken: machineId.securityToken,
          imei: machineId.imei,
          merchantStorePosCode: machineId.merchantStorePosCode,
        }
      )
      .then(async (statusRes) => {
        if (statusRes.data.message === 'expired') {
          await supabase
            .from('AllotmentTransactions')
            .update({ status: 'expired' })
            .eq('paymentDetails->ptrnNo', ptrnNo)
            .then(async (_re) => {
              if (!flag) {
                setTransactionOpen(false);
                setPtrnNo('');
                setMode('expired');
                setMessage('Transaction Expired');
              }
            });
        } else if (statusRes.data.message === 'completed') {
          let leadstatus = ''
          let allotmentstatus = ''
          let totalAmount = 0
          if (allotment?.paymentId?.eventId?.adjustTokenAmt && allotment?.paymentId?.status !== 'adjusted' && allotment?.paymentId?.pricingType !== 'preselect') {
            totalAmount = (parseInt(allotment.bookingAmt?.total) - allotment?.paymentId?.paidAmount)
          } else {
            totalAmount = (parseInt(allotment.bookingAmt?.total))
          }
          let fullAmount = amountToBePaid ? amountToBePaid : totalAmount
          if (fullAmount - allotment.paidAmount > parseInt(myamt)) {
            allotmentstatus = 'Partial Payment Done'
            if (allotment.pricingType === 'preselect') {
              leadstatus = 'Preselect Partial Payment Done'
            } else {
              leadstatus = 'Allotment Partial Payment Done'
            }
          } else {
            allotmentstatus = 'Payment Complete'
            if (allotment.pricingType === 'preselect') {
              leadstatus = 'Preselect Price Confirmation Pending'
            } else {
              leadstatus = 'Allotment Payment Complete'
            }
          }
          let paidAmt = allotment.paidAmt ? allotment.paidAmt : { ocr: 0, gst: 0, sdr: 0 }
          let currentAmt = parseInt(myamt)
          let ocr = 0
          let gst = 0
          let sdr = 0
          if (currentAmt <= (allotment.bookingAmt.ocr - paidAmt.ocr)) {
            ocr = currentAmt
            currentAmt = 0
          } else {
            ocr = (allotment.bookingAmt.ocr - paidAmt.ocr)
            currentAmt = currentAmt - (allotment.bookingAmt.ocr - paidAmt.ocr)
          }
          if (currentAmt <= (allotment.bookingAmt.gst - paidAmt.gst)) {
            gst = currentAmt
            currentAmt = 0
          } else {
            gst = (allotment.bookingAmt.gst - paidAmt.gst)
            currentAmt = currentAmt - (allotment.bookingAmt.gst - paidAmt.gst)
          }
          if (currentAmt <= (allotment.bookingAmt.sdr - paidAmt.sdr)) {
            sdr = currentAmt
            currentAmt = 0
          } else {
            sdr = (allotment.bookingAmt.sdr - paidAmt.sdr)
            currentAmt = currentAmt - (allotment.bookingAmt.sdr - paidAmt.sdr)
          }
          paidAmt = {
            ocr: paidAmt.ocr + ocr,
            gst: paidAmt.gst + gst,
            sdr: paidAmt.sdr + sdr
          }
          await supabase.from('AllotmentPayment').update({ paidAmt: paidAmt, status: allotmentstatus, preselectConfirmation: leadstatus === 'Preselect Price Confirmation Pending' ? 'confirmation pending' : allotment.preselectConfirmation, paidAmount: parseFloat(allotment.paidAmount + parseInt(myamt)), }).eq('allotmentPaymentId', allotment.allotmentPaymentId).then(async (_resp) => {
            await supabase.from('AllotmentTransactions').update({ ocr: ocr, gst: gst, sdr: sdr, status: 'complete' }).eq('paymentDetails->ptrnNo', ptrnNo).then(async (_re) => {
              // await supabase.from('LeadStatus').update({ status: ((payments.data[i].totalCost - allotment.paidAmount) > myamt) ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete' }).eq('leadId', payments.data[0].leadId).then((_r) => {
              await supabase.from('LeadStatus').update({ status: leadstatus }).eq('leadId', allotment.leadId.leadId).then(async (_r) => {
                let obj = {
                  leadId: allotment.leadId.leadId,
                  leadStatus: leadstatus,
                  message: leadstatus
                }
                addLeadLogs(obj).then((leadLog) => { console.log(leadLog) }).catch((err) => { console.log('leadlog', err) })
                if (allotment.pricingType === 'preselect') {
                  await supabase.from('EventTokenLeadRelations').update({ paidAmount: fullAmount, status: 'alloted' }).eq('paymentId', allotment.paymentId.paymentId).then((rr) => {
                    if (!flag) {
                      setTransactionOpen(false);
                      setAmount(myamt);
                      setPtrnNo('');
                      setMode('complete');
                    }
                    setAllotmentDetails((pre) => {
                      pre.paidAmount = pre.paidAmount + parseInt(myamt);
                      return { ...pre };
                    });
                  })
                } else {
                  if (allotment.paidAmount + parseInt(amount) >= fullAmount) {
                    if (!allotment.kycFormFilled) {
                      updateInventoryStatus("card", myamt, flag)
                    }
                    // else {
                    //   callBookingApis()
                    // }
                  } else {
                    if (!flag) {
                      setTransactionOpen(false);
                      setAmount(myamt);
                      setPtrnNo('');
                      setMode('complete');
                    }
                    setAllotmentDetails((pre) => {
                      pre.paidAmount = pre.paidAmount + parseInt(myamt);
                      return { ...pre };
                    });
                  }
                }
              });
            });
          });
        } else {
          if (flag) {
            setMode('pending');
            setTimestamp(time);
            setMessage('Waiting for payment on POS machine');
            setPtrnNo(ptrnNo);
            setOpenLoaderModal(true);
            dismissLoader();
          }
          checkStatus(ptrnNo, false, allotment, myamt, time, machineId);
        }
      })
      .catch((err) => {
        console.log(err);
        setPtrnNo('');
        setMode('expired');
        setMessage('Please check POS internet connectivity');
      });
  }

  function sendPaymentLink() {
    if (!amount || amount === 0) {
      errorTost("Amount cannot be 0")
    } else {
      presentLoader()
      // if (allotmentDetails.paidAmount == 0 && allTransactions.length === 0) {
      if (allotmentDetails.status === 'On Hold') {
        axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}bookings/send-payment-email`, { leadName: allotmentDetails?.leadId?.personId?.name, allotmentPaymentId: allotmentDetails.allotmentPaymentId, leadEmail: allotmentDetails?.leadId?.personId?.email }).then((reqRes) => {
          supabase.from('InventoryStatus').select('*').eq('status', "Payment Pending").then((statusRes) => {
            if (allotmentDetails?.inventoryMergedId && allotmentDetails?.inventoryMergedId?.inventoryMergeId !== '') {
              supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.inventoryMergedId.unit1Id.unitId).then((updateRes) => {
                supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.inventoryMergedId.unit1Id.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "alloted", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.inventoryMergedId.unit1Id.projectId.projectId }).then((updateRes) => {
                  supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.inventoryMergedId.unit2Id.unitId).then((updateRes) => {
                    supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.inventoryMergedId.unit1Id.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "alloted", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.inventoryMergedId.unit1Id.projectId.projectId }).then((updateRes) => {
                      if (allotmentDetails.pricingType === 'preselect') {
                        sendLink()
                      } else {
                        supabase.from('LeadStatus').update({ status: 'Allotment Payment Pending' }).eq('leadId', allotmentDetails.leadId.leadId).then((resp) => {
                          let obj = {
                            leadId: allotmentDetails.leadId.leadId,
                            leadStatus: `Allotment Payment Pending`,
                            message: `Unit:${allotmentDetails?.inventoryMergedId?.unit1Id?.unitNo}-${allotmentDetails?.inventoryMergedId?.unit2Id?.unitNo}, alloted by ${JSON.parse(localStorage.getItem('user')).name}, PricingType: ${allotmentDetails.pricingType}, Event:${allotmentDetails?.paymentId?.eventId?.title}, Project: ${allotmentDetails?.inventoryMergedId?.unit1Id?.projectId?.projectName}`
                          }
                          addLeadLogs(obj).then((leadLog) => { console.log(leadLog) }).catch((err) => { console.log('leadlog', err) })
                          sendLink()
                        })
                      }
                    })
                  })
                })
              })
            } else {
              supabase.from('Inventory').update({ inventoryStatusId: statusRes.data[0].inventoryStatusId }).eq('unitId', allotmentDetails.unitId.unitId).then((updateRes) => {
                supabase.from('InventoryLogs').insert({ unitId: allotmentDetails.unitId.unitId, leadId: allotmentDetails.leadId.leadId, userId: JSON.parse(localStorage.getItem('user')).userId, status: "alloted", pricingType: allotmentDetails.pricingType, eventId: allotmentDetails?.paymentId?.eventId.eventId, projectId: allotmentDetails.unitId.projectId.projectId }).then((updateRes) => {
                  if (allotmentDetails.pricingType === 'preselect') {
                    sendLink()
                  } else {
                    supabase.from('LeadStatus').update({ status: 'Allotment Payment Pending' }).eq('leadId', allotmentDetails.leadId.leadId).then((resp) => {
                      let obj = {
                        leadId: allotmentDetails.leadId.leadId,
                        leadStatus: `Allotment Payment Pending`,
                        message: `Unit:${allotmentDetails?.unitId.unitNo}, alloted by ${JSON.parse(localStorage.getItem('user')).name}, PricingType: ${allotmentDetails?.pricingType}, Event:${allotmentDetails?.paymentId?.eventId?.title}, Project: ${allotmentDetails?.unitId?.projectId?.projectName}`
                      }
                      addLeadLogs(obj).then((leadLog) => { console.log(leadLog) }).catch((err) => { console.log('leadlog', err) })
                      sendLink()
                    })
                  }
                })
              })
            }
          })
        })
      } else {
        // axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}payments/create-payment-link`, { mode: 'allotment', amount: amount, leadName: allotmentDetails.leadId.personId.name, leadEmail: allotmentDetails.leadId.personId.email, leadContactNumber: allotmentDetails.leadId.personId.contactNumber }).then((resp) => {
        sendLink()
      }
    }
  }

  function sendLink() {
    // axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}payments/create-payment-link`, { mode: 'allotment', amount: amount, leadName: allotmentDetails.leadId.personId.name, leadEmail: allotmentDetails.leadId.personId.email, leadContactNumber: allotmentDetails.leadId.personId.contactNumber }).then((resp) => {
    const obj = { type: allotmentDetails.pricingType === 'preselect' ? 'preselect' : 'allotment', mode: 'allotment', amount: amount, leadId: allotmentDetails.leadId.leadId, unitId: allotmentDetails.unitId ? allotmentDetails.unitId.unitId : null, inventoryMergeId: allotmentDetails?.inventoryMergedId?.inventoryMergeId ? allotmentDetails?.inventoryMergedId?.inventoryMergeId : null, allotmentPaymentId: allotmentDetails.allotmentPaymentId, leadName: allotmentDetails.leadId.personId.name, leadEmail: allotmentDetails.leadId.personId.email, leadContactNumber: allotmentDetails.leadId.personId.contactNumber }
    createPaymentLink(obj).then((resp) => {
      dismissLoader()
      successTost("Link Shared successfully")
      if (allotmentDetails.paidAmount + parseInt(amount) >= amountToBePaid) {
        setOpenPaymentModal(false)
      }
      setAllotmentDetails((pre) => { pre.paidAmount = pre.paidAmount + parseInt(amount); return { ...pre } })
    }).catch((err) => {
      dismissLoader()
      console.log(err)
    })
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  }

  function callBookingApis() {
    axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}bookings/send-welcome-email`, { allotmentPaymentId: allotmentDetails.allotmentPaymentId }).then((resp) => {

    })
  }

  return (
    // <Modal open={true}
    // aria-labelledby="parent-modal-title"
    // aria-describedby="parent-modal-description">
    <div className={cssClasses.mainContainer}>
      {allotmentDetails?.allotmentPaymentId && (
        <div className={cssClasses.content}>
          <div className={cssClasses.allotment}>
            <div className={cssClasses.allotmentDetails}>
              <div className={cssClasses.leadDetails}>
                <div className={cssClasses.lead}>
                  <p className={cssClasses.leadName}>
                    {allotmentDetails?.leadId?.personId?.name}
                  </p>
                  <p className={cssClasses.leadDisplayId}>
                    VJ{allotmentDetails?.leadId?.leadDisplayId.substring(0, 8)}-
                    {allotmentDetails?.leadId?.leadDisplayId.substring(8, 12)}
                  </p>
                </div>
                <div className={cssClasses.detail}>
                  <p style={{ marginBottom: '1rem' }}>
                    +{allotmentDetails?.leadId?.personId?.contactNumber}
                  </p>
                  <p>{allotmentDetails?.leadId?.personId?.email}</p>
                </div>
              </div>
              <div className={cssClasses.unitDetails}>
                <p className={cssClasses.unitLabel}>Payment Mode :</p>
                <Box paddingLeft={"1rem"}>
                  <CustomRadio
                    value={paymentMode}
                    optionList={
                      allotmentDetails?.paymentId
                        ? allotmentDetails?.paymentId?.eventId[allotmentDetails.pricingType === 'preselect' ? 'preselectPaymentModes' : desk]
                        :
                        allotmentDetails?.inventoryMergeId ?
                          allotmentDetails?.inventoryMergedId?.unit1Id?.projectId?.paymentModes ?? ['Virtual Acc', 'Razorpay', 'Card', 'Cheque']
                          :
                          allotmentDetails?.unitId?.projectId?.paymentModes ?? ['Virtual Acc', 'Razorpay', 'Card', 'Cheque']

                      // ['Virtual Acc', 'Razorpay', 'Card', 'Cheque']
                    }
                    onChangeValue={(e) => {
                      if (
                        // (e === 'Cheque' || e === 'Virtual Acc') &&
                        (e === 'Cheque') &&
                        allotmentDetails?.paymentId?.eventId?.minOnlineAmt &&
                        allotmentDetails?.paymentId?.eventId?.minOnlineAmt > 0 &&
                        allotmentDetails.paidAmount <
                        allotmentDetails.paymentId.eventId.minOnlineAmt
                      ) {
                        errorTost(
                          `Please pay ${allotmentDetails.paymentId.eventId.minOnlineAmt -
                          allotmentDetails.paidAmount
                          } online to continue`
                        );
                      } else {
                        if (e === 'Razorpay' && allotmentDetails.pricingType === 'preselect') {
                          setAmount(amountToBePaid - parseInt(allotmentDetails.paidAmount))
                        }
                        setPaymentMode(e);
                      }
                    }}
                  />
                </Box>
              </div>
              {paymentMode === 'Virtual Acc' &&
                allotmentDetails?.leadId?.razorpayCustomerId && (
                  <div className={cssClasses.unitDetails}>
                    <p className={cssClasses.unitLabel}>
                      Virtual Acc Details :
                    </p>
                    <p className={cssClasses.unitLabel}>
                      Razorpay Customer Id :{' '}
                      {allotmentDetails.leadId.razorpayCustomerId}
                    </p>
                    <p className={cssClasses.unitLabel}>
                      Bank Account Number :{' '}
                      {
                        allotmentDetails.leadId.virtualAccDetails
                          .bankAccountNumber
                      }
                    </p>
                    <p className={cssClasses.unitLabel}>
                      Bank IFSC Code :{' '}
                      {allotmentDetails.leadId.virtualAccDetails.bankIFSCCode}
                    </p>
                    <p className={cssClasses.unitLabel}>
                      Bank Beneficiary Name :{' '}
                      {
                        allotmentDetails.leadId.virtualAccDetails
                          .bankBeneficiaryName
                      }
                    </p>
                  </div>
                )}
              {paymentMode !== 'Virtual Acc' && (
                <div style={{ width: '100%' }}>
                  {paymentMode === 'Card' && allMachines.length > 0 &&
                    <div style={{ marginBottom: '2rem' }}>
                      <DropDown list={allMachines} selectedValue={machine} label={'Select Machine'} mandatory={true}
                        onChangeSelect={(e) => { setMachine(e) }}
                      />
                    </div>
                  }
                  {paymentMode === 'Card' && machine &&
                    <CustomInput
                      disabled={machine ? false : true}
                      max={amountToBePaid - allotmentDetails.paidAmount}
                      placeholder={'Enter amount'}
                      inputType={'number'}
                      position={'start'}
                      image={'true'}
                      labelText={RupeeIcon}
                      value={amount}
                      handleChange={(_value) => {
                        setAmount(_value);
                        if (_value !== '') {
                          setPaymentHelperText((pre) => {
                            pre.PartialAmount = '';
                            return { ...pre };
                          });
                          // PaymentHelperText.PartialAmount = '';
                        } else {
                          setPaymentHelperText((pre) => {
                            pre.PartialAmount = 'Please enter partial amount';
                            return { ...pre };
                          });
                          // PaymentHelperText.PartialAmount =
                          //     "Please enter partial amount"
                        }

                        if (
                          parseInt(_value) >
                          (amountToBePaid - allotmentDetails.paidAmount)
                        ) {
                          setPaymentHelperText((pre) => {
                            pre.PartialAmount =
                              'Amount should be less than or equal to amount to be paid';
                            return { ...pre };
                          });
                          // PaymentHelperText.PartialAmount = "amount should less than or equal to amount to be paid"
                        } else {
                          setPaymentHelperText((pre) => {
                            pre.PartialAmount = '';
                            return { ...pre };
                          });
                          // PaymentHelperText.PartialAmount = "";
                        }
                      }}
                      helperText={PaymentHelperText.PartialAmount}
                    />
                  }
                  {paymentMode !== 'Card' &&
                    <CustomInput
                      disabled={allotmentDetails?.pricingType === 'preselect' ? true : false}
                      max={amountToBePaid - allotmentDetails.paidAmount}
                      placeholder={'Enter amount'}
                      inputType={'number'}
                      position={'start'}
                      image={'true'}
                      labelText={RupeeIcon}
                      value={amount}
                      handleChange={(_value) => {
                        setAmount(_value);
                        if (_value !== '') {
                          setPaymentHelperText((pre) => {
                            pre.PartialAmount = '';
                            return { ...pre };
                          });
                          // PaymentHelperText.PartialAmount = '';
                        } else {
                          setPaymentHelperText((pre) => {
                            pre.PartialAmount = 'Please enter partial amount';
                            return { ...pre };
                          });
                          // PaymentHelperText.PartialAmount =
                          //     "Please enter partial amount"
                        }

                        if (
                          parseInt(_value) >
                          (amountToBePaid - allotmentDetails.paidAmount)
                        ) {
                          setPaymentHelperText((pre) => {
                            pre.PartialAmount =
                              'Amount should be less than or equal to amount to be paid';
                            return { ...pre };
                          });
                          // PaymentHelperText.PartialAmount = "amount should less than or equal to amount to be paid"
                        } else {
                          setPaymentHelperText((pre) => {
                            pre.PartialAmount = '';
                            return { ...pre };
                          });
                          // PaymentHelperText.PartialAmount = "";
                        }
                      }}
                      helperText={PaymentHelperText.PartialAmount}
                    />
                  }
                </div>
              )}
              {paymentMode === 'Cheque' && (
                <Box width={'100%'}>
                  <Box className={cssClasses.header2} mb={2}>
                    Cheque Details
                  </Box>

                  <Box className={cssClasses.SearchDiv}>
                    <Box className={cssClasses.InputDiv}>
                      <Box className={cssClasses.subTitle}>Issuer Name <span style={{ color: "red" }}>*</span></Box>
                      <CustomInput
                        value={chequeDetails.issuerName}
                        handleChange={(e) => {
                          setChequeDetails((pre) => {
                            pre.issuerName = e;
                            return { ...pre };
                          });
                          setChequeHelperText((pre) => {
                            if (e === '') {
                              pre.issuerName = 'Please enter issuer name';
                            } else {
                              pre.issuerName = '';
                            }
                            return { ...pre };
                          });
                        }}
                        helperText={chequeHelperText.issuerName}
                        inputType={'text'}
                      />
                    </Box>

                    <Box className={cssClasses.InputDiv}>
                      <Box className={cssClasses.subTitle}>Cheque Number <span style={{ color: "red" }}>*</span></Box>
                      <CustomInput
                        value={chequeDetails.chequeNumber}
                        handleChange={(e) => {
                          setChequeDetails((pre) => {
                            pre.chequeNumber = e;
                            return { ...pre };
                          });
                          setChequeHelperText((pre) => {
                            if (e === '') {
                              pre.chequeNumber = 'Please enter cheque number';
                            } else {
                              pre.chequeNumber = '';
                            }
                            return { ...pre };
                          });
                        }}
                        helperText={chequeHelperText.chequeNumber}
                        inputType={'number'}
                      />
                    </Box>

                    <Box className={cssClasses.InputDiv}>
                      <Box className={cssClasses.subTitle}>Bank Name <span style={{ color: "red" }}>*</span></Box>
                      <Box>
                        <DropDown
                          selectedValue={chequeDetails.bankName}
                          helperText={chequeHelperText.bankName}
                          onChangeSelect={(e) => {
                            setChequeDetails((pre) => {
                              pre.bankName = e;
                              return { ...pre };
                            });
                            setChequeHelperText((pre) => {
                              pre.bankName = '';
                              return { ...pre };
                            });
                          }}
                          list={[
                            'Bank of Baroda',
                            'Bank of India',
                            'Bank of Maharashtra',
                            'Canara Bank',
                            'Central Bank of India',
                            'Indian Bank',
                            'Indian Overseas Bank',
                            'Punjab & Sind Bank',
                            'Punjab National Bank',
                            'State Bank of India',
                            'UCO Bank',
                            'Union Bank of India',
                          ]}
                          style={{
                            background: '#F2F4F7',
                            selectedColor: '#667085',
                          }}
                        />
                      </Box>
                    </Box>

                    <Box className={cssClasses.InputDiv}>
                      <Box className={cssClasses.subTitle} mb={1}>
                        Cheque Date <span style={{ color: "red" }}>*</span>
                      </Box>
                      <DateComponent
                        helperText={chequeHelperText.chequeDate}
                        onChangeDate={(e) => {
                          setChequeDetails((pre) => {
                            pre.chequeDate = e;
                            return { ...pre };
                          });
                          setChequeHelperText((pre) => {
                            pre.chequeDate = '';
                            return { ...pre };
                          });
                        }}
                        value={chequeDetails.chequeDate}
                      />
                    </Box>
                  </Box>

                  <Box>
                    <Box className={cssClasses.subTitle} mt={2.4}>
                      Payment Remarks
                    </Box>
                    <Box width={'100%'}>
                      <CustomInput
                        value={chequeDetails.remarks}
                        handleChange={(e) => {
                          setChequeDetails((pre) => {
                            pre.remarks = e;
                            return { ...pre };
                          });
                        }}
                        inputType={'TextArea'}
                        rows={4}
                        placeholder={'Enter a description...'}
                      />
                    </Box>
                  </Box>

                  <Box
                    style={{ position: 'relative' }}
                    width={'fit-content'}
                    mt={2.4}
                  >
                    <Button
                      style={{
                        fontSize: '1.6rem',
                        lineHeight: '2.4rem',
                        color: '#007FFF',
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #007FFF',
                        borderRadius: '25px',
                      }}
                      btnIcon={<img src={PinIcon} alt={''} />}
                      iconPosition={'left'}
                      padding={'0.8rem 1.6rem'}
                      btnName={'Attach Cheque'}
                      clicked={() => {
                        setOpenCaptureModal(true);
                      }}
                    />
                    {/* <input style={{
                      position: 'absolute',
                      left: '0',
                      display: 'none'
                    }} onChange={(e) => { setChequeDetails((pre) => { pre.chequeImg = e.target.files[0]; return { ...pre } }) }} type='file' id="chequeImg" accept="image/*" /> */}
                  </Box>
                </Box>
              )}
            </div>
            <div className={cssClasses.allotmentDetails}>
              <div className={cssClasses.unitDetails}>
                <p className={cssClasses.unitLabel}>Unit :</p>
                <p className={cssClasses.unitInfo}>
                  {allotmentDetails?.unitId?.inventoryTypeId?.type ? allotmentDetails?.unitId?.inventoryTypeId?.type : allotmentDetails?.inventoryMergedId?.unit1Id.inventoryTypeId.type} |{' '}
                  {allotmentDetails?.unitId?.unitNo ? allotmentDetails?.unitId?.unitNo : allotmentDetails?.inventoryMergedId?.unit1No}  {allotmentDetails?.inventoryMergedId?.unit2No} |{' '}
                  {allotmentDetails?.unitId?.projectId?.projectName ? allotmentDetails?.unitId?.projectId?.projectName : allotmentDetails?.inventoryMergedId?.unit1Id?.projectId?.projectName} |{' '}
                  {allotmentDetails?.paymentId?.eventId
                    ? allotmentDetails?.paymentId?.eventId?.title
                    : ''}
                </p>
              </div>
              <div className={cssClasses.unitDetails}>
                <p className={cssClasses.unitLabel}>Amount to be paid :</p>
                <p className={cssClasses.unitInfo}>
                  ₹ {numberWithCommas(amountToBePaid - allotmentDetails?.paidAmount) !== NaN ? numberWithCommas(amountToBePaid - allotmentDetails?.paidAmount) : 0}
                  {allotmentDetails?.paymentId?.eventId?.adjustTokenAmt && allotmentDetails?.paymentId?.status !== 'adjusted' &&
                    < span > ({amountToBePaid - allotmentDetails?.paidAmount + allotmentDetails?.paymentId?.paidAmount} - token amount: {numberWithCommas(allotmentDetails?.paymentId?.paidAmount)})</span>
                  }
                </p>
                {allotmentDetails?.paymentId?.eventId?.minOnlineAmt > 0 && (
                  <p className={cssClasses.unitLabel}>
                    Minimum online amount : ₹{' '}
                    {numberWithCommas(allotmentDetails.paymentId.eventId.minOnlineAmt)}
                  </p>
                )}
              </div>
              {allTransactions.length > 0 &&
                <div className={cssClasses.unitDetails}>
                  <div style={{
                    maxHeight: '40rem',
                    overflow: 'auto'
                  }}>
                    <div>
                      <p className={cssClasses.unitLabel}>All Transactions : </p>
                    </div>
                    <div style={{ marginTop: "2rem" }}>
                      <Timeline position='right' sx={[
                        {
                          padding: "0rem !important",
                          [`& .MuiTimeline-root `]: {
                            padding: "0rem !important",
                          },

                          "& . MuiTypography-root": {
                            padding: "19px 16px !important",
                          },
                          [`& .MuiTimelineItem-root:before`]: {
                            flex: "0rem !important",
                            padding: "0rem !important",
                            "-webkitFlex": "none !important",
                            //  content:'none '
                          },
                        }
                      ]}>
                        {allTransactions.map((m) => (
                          <TimelineItem>
                            <TimelineSeparator>
                              <TimelineConnector />
                              {/* <TimelineDot> */}
                              <div style={{ width: "5rem", height: "5rem" }}>
                                {m.status === 'complete' &&
                                  <CheckCircleOutlineIcon style={{ color: "#32D583", width: "100%", height: "100%" }} />
                                }
                                {(m.status === 'expired' || m.status === 'failed') &&
                                  <HighlightOffIcon style={{ color: "red", width: "100%", height: "100%" }} />
                                }
                                {m.status === 'pending' &&
                                  <ErrorOutlineIcon style={{ color: "#FEC84B", width: "100%", height: "100%" }} />
                                }
                              </div>
                              {/* </TimelineDot> */}
                              <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent sx={{ py: '12px', px: 2 }}>
                              <Typography variant="h6" component="span">
                                <p style={{ fontSize: "1.6rem", fontFamily: "Inter-Medium" }}>
                                  {m.modeOfPayment}
                                </p>
                              </Typography>
                              <Typography>
                                <p style={{ fontSize: "1.4rem", fontFamily: "Inter-Regular" }}>
                                  amount : {numberWithCommas(m.amount)}
                                </p>
                              </Typography>
                              <Typography>
                                <p style={{ fontSize: "1.4rem", fontFamily: "Inter-Regular" }}>
                                  {new Date(m.last_updated_at).toLocaleString()}
                                </p>
                              </Typography>
                            </TimelineContent>
                          </TimelineItem>
                        ))}
                      </Timeline>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          {/* <div className={cssClasses.floorPlanDetails}></div> */}
        </div>
      )
      }
      <div className={cssClasses.footer}>
        <div style={{
          display: 'flex',
          gap: '2rem'
        }}>
          <div>
            <Button
              style={{
                fontSize: '1.4rem',
                lineHeight: '2rem',
                color: '#344054',
                backgroundColor: '#FFFFFF',
                borderRadius: '0.8rem',
              }}
              padding={'0.85rem 2.6rem'}
              btnName={'Cancel'}
              clicked={() => setOpenPaymentModal(false)}
            />
          </div>
          {/* {showBackToFastBooking && */}
          <div>
            <Button
              style={{
                fontSize: '1.4rem',
                lineHeight: '2rem',
                color: '#344054',
                backgroundColor: '#FFFFFF',
                borderRadius: '0.8rem',
              }}
              padding={'0.85rem 2.6rem'}
              btnName={'Go to fast booking'}
              clicked={() => navigate('/home/FastBooking')}
            />
          </div>
          {/* } */}
        </div>
        {!transactionOpen &&
          paymentMode !== 'Virtual Acc' &&
          paymentMode !== 'Razorpay' && (
            <div>
              <Button
                disable={(parseInt(amount) === 0 || amount === '') ? true : false}
                style={{
                  fontSize: '1.6rem',
                  lineHeight: '2.4rem',
                  color: '#FFF',
                  backgroundColor: '#007FFF',
                  borderRadius: '0.8rem',
                }}
                padding={'0.65rem 2.5rem'}
                btnName={'Submit'}
                clicked={() => OnSubmit()}
              />
            </div>
          )}
        {!transactionOpen &&
          paymentMode === 'Razorpay' && (
            <div>
              <Button
                disable={(parseInt(amount) === 0 || amount === '') ? true : false}
                style={{
                  fontSize: '1.6rem',
                  lineHeight: '2.4rem',
                  color: '#FFF',
                  backgroundColor: '#007FFF',
                  borderRadius: '0.8rem',
                }}
                padding={'0.65rem 2.5rem'}
                btnName={'Send Payment Link'}
                clicked={() => sendPaymentLink()}
              />
            </div>
          )
        }
      </div>
      {
        isLoading && (
          <LoaderWithMsg isLoading={isLoading} loaderMsg={loaderMsg} />
        )
      }
      {
        openCaptureModal && (
          <CameraCapture
            CapturePhoto={(e) => setOpenCaptureModal(true)}
            WebCamOpen={openCaptureModal}
            HandleCaptureClose={() => setOpenCaptureModal(false)}
            InitialData={chequeDetails.chequeImg}
            Flag={false}
            UploadedData={(_v) => {
              console.log(_v);
              setChequeDetails((pre) => {
                pre.chequeImg = _v;
                return { ...pre };
              });
            }}
            SaveData={() => setOpenCaptureModal(false)}
          />
        )
      }
      {
        openLoaderModal && (
          <LoaderModal
            timestamp={timestamp}
            ptrnNo={ptrnNo}
            message={message}
            mode={mode}
            amount={amount}
            allotmentDetails={allotmentDetails}
            open={openLoaderModal}
            handleClose={() => {
              if (allotmentDetails.paidAmount + parseInt(amount) >= amountToBePaid) {
                setOpenPaymentModal(false);
                setOpenLoaderModal(false);
              } else {
                setOpenLoaderModal(false);
              }
            }}
          />
        )
      }
    </div >
    // </Modal>
  );
}
